module.exports = __webpack_public_path__ + "static/media/morning.b30d8eca.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gifs/morning.gif
// module id = 847
// module chunks = 0